<template>
  <CBox>
    <OmtRow mb="8px">
      <OmtTypography as="h1-bold" lineHeight="32px">{{ title }}</OmtTypography>
    </OmtRow>
    <OmtRow mb="8px">
      <OmtTypography as="p1" lineHeight="22px">
        <span v-html="text" />
      </OmtTypography>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtInput
        v-model="search"
        variant="filled"
        iconRight="search"
        :placeholder="placeholder"
        class="input-search-exames"
        @keydown.enter.prevent="emitSearchValue"
      />
    </OmtRow>
  </CBox>
</template>

<script>
export default {
  name: "ExamesSearch",
  props: {
    title: { type: String, required: true, default: "Buscar exames" },
    text: {
      type: String,
      required: false
    },
    placeholder: { type: String, required: false },
    initialValue: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      search: this.initialValue ?? ""
    };
  },
  watch: {
    search: function () {
      this.emitSearchValue();
    }
  },
  methods: {
    emitSearchValue() {
      this.$emit("search", this.search);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-search-exames ::v-deep path {
  color: #4e4e4e;
}
</style>
